export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based, so add 1
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const getDates = (series) => {
    let startDate = series?.[0].date;
    let endDate = series?.[series.length - 1].date;
    return [startDate, endDate];
};


export const getMostRecentSeriesAndGame = (data_, now) => {
    // Convert now to a consistent format
    const today = now;
    const todayFormatted = formatDate(today);
    
    // Filter series to only include those with dates in the past or today
    // Using string comparison to avoid timezone issues
    const pastOrTodaySeries = data_.filter((series) =>
        series.dates.some((game) => game.date <= todayFormatted)
    );
    
    // If no past or today series found, find the next upcoming series
    if (pastOrTodaySeries.length === 0) {
        console.log("No past or today series found, finding upcoming series");
        
        // Find next upcoming series
        const upcomingSeries = data_
            .filter(series => series.dates.some(game => game.date > todayFormatted))
            .sort((a, b) => {
                // Get earliest game date from each series
                const earliestA = a.dates
                    .map(game => game.date)
                    .sort()[0];
                const earliestB = b.dates
                    .map(game => game.date)
                    .sort()[0];
                    
                // Sort by earliest date (ascending)
                return earliestA.localeCompare(earliestB);
            });
            
        if (upcomingSeries.length > 0) {
            const nextSeries = upcomingSeries[0];
            // Get earliest game from that series
            const nextGame = nextSeries.dates
                .sort((a, b) => a.date.localeCompare(b.date))[0];
                
            return {
                recentSeries: nextSeries,
                recentGame: nextGame
            };
        }
        
        return { recentSeries: null, recentGame: null };
    }
    
    // Sort the series by the most recent game date in each series
    const sortedSeries = pastOrTodaySeries.sort((a, b) => {
        // Get past or today games for each series
        const pastGamesA = a.dates
            .filter(game => game.date <= todayFormatted)
            .map(game => game.date);
            
        const pastGamesB = b.dates
            .filter(game => game.date <= todayFormatted)
            .map(game => game.date);
            
        // Get the most recent date using string comparison
        const mostRecentGameA = pastGamesA.sort().pop();
        const mostRecentGameB = pastGamesB.sort().pop();
        
        // Sort descending (most recent first)
        return mostRecentGameB.localeCompare(mostRecentGameA);
    });
    
    // Get the most recent series
    const mostRecentSeriesFound = sortedSeries[0];
    
    // Find the most recent game in that series using the helper function
    const resultGame = resultgetSeriesAndGameByDate(
        mostRecentSeriesFound,
        now
    );
    
    return {
        recentSeries: mostRecentSeriesFound,
        recentGame: resultGame.recentGame,
    };
};

const resultgetSeriesAndGameByDate = (series, now) => {
    const today = formatDate(now);
    let mostRecentGame = null;
    
    // Find a game in the series that matches the selected date
    const todayGame = series.dates.find((game) => game.date === today);
    
    if (todayGame) {
        // If a game is found on the selected date, return the game
        return { recentGame: todayGame };
    }
    
    // Find the most recent game in the series that is before the selected date
    // Using string comparison for consistency
    const recentGame = series.dates
        .filter((game) => game.date < today)
        .sort((a, b) => b.date.localeCompare(a.date))[0];
    
    // Update the most recent game if found
    if (recentGame) {
        mostRecentGame = recentGame;
    }
    
    // If no game is found on the selected date, return the most recent game in the past
    if (mostRecentGame) {
        return { recentGame: mostRecentGame };
    }
    
    // If no past game is found, find the next upcoming game
    const upcomingGame = series.dates
        .filter((game) => game.date > today)
        .sort((a, b) => a.date.localeCompare(b.date))[0];
        
    if (upcomingGame) {
        console.log("No recent past game found. Selecting upcoming game instead.");
        return { recentGame: upcomingGame };
    }
    
    // If no past or upcoming game is found (shouldn't happen)
    console.log("No games found in this series.");
    return { recentGame: null };
};